import { render } from "./HomeContact.vue?vue&type=template&id=b7716538&scoped=true&ts=true"
import script from "./HomeContact.vue?vue&type=script&lang=ts"
export * from "./HomeContact.vue?vue&type=script&lang=ts"

import "./HomeContact.vue?vue&type=style&index=0&id=b7716538&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7716538"]])

export default __exports__